import removeMd from 'remove-markdown';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const getSchemaFAQPage = ({
  items
}) => ({
  '@context': 'https://schema.org/',
  '@type': 'FAQPage',
  mainEntity: items.map(item => ({
    '@type': 'Question',
    name: removeMd((item === null || item === void 0 ? void 0 : item.question) || ''),
    // eslint-disable-next-line sort-keys
    acceptedAnswer: {
      '@type': 'Answer',
      text: removeMd((item === null || item === void 0 ? void 0 : item.answer) || '')
    }
  }))
});